// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuperAdminSchoolFormsPanel {
  border-radius: 6px;
}

.SuperAdminSchoolFormsDetailsGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 12px;
}

.SuperAdminSchoolFormsDetailsGrid > div {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 10px;
  background: #fafafa;
}

.SuperAdminSchoolFormsDetailsGrid span {
  display: block;
  font-size: 12px;
  margin-bottom: 4px;
}

.SuperAdminSchoolFormsDetailsGrid strong {
  display: block;
  word-break: break-word;
}

.SuperAdminSchoolFormsPicValue {
  padding: 8px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fafafa;
  word-break: break-all;
}

.SuperAdminSchoolFormsJson {
  margin-top: 10px;
  padding: 12px;
  border-radius: 6px;
  background: #f8f9fa;
  border: 1px solid #e5e7eb;
  max-height: 360px;
  overflow: auto;
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperAdminApp/School/Forms/SuperAdminSchoolForms.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB","sourcesContent":[".SuperAdminSchoolFormsPanel {\n  border-radius: 6px;\n}\n\n.SuperAdminSchoolFormsDetailsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\n  gap: 12px;\n}\n\n.SuperAdminSchoolFormsDetailsGrid > div {\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 10px;\n  background: #fafafa;\n}\n\n.SuperAdminSchoolFormsDetailsGrid span {\n  display: block;\n  font-size: 12px;\n  margin-bottom: 4px;\n}\n\n.SuperAdminSchoolFormsDetailsGrid strong {\n  display: block;\n  word-break: break-word;\n}\n\n.SuperAdminSchoolFormsPicValue {\n  padding: 8px 10px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #fafafa;\n  word-break: break-all;\n}\n\n.SuperAdminSchoolFormsJson {\n  margin-top: 10px;\n  padding: 12px;\n  border-radius: 6px;\n  background: #f8f9fa;\n  border: 1px solid #e5e7eb;\n  max-height: 360px;\n  overflow: auto;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
